import type { TMake } from '@src-common/api/definitions/w4d-cars-types';

import { useMakeConfig } from './useMakeConfig';

const useModels = (make?: TMake) => {
  const makeConfig = useMakeConfig(make);

  if (!makeConfig || !make) {
    return [];
  }

  return makeConfig.models.map(modelOptions => ({
    title: modelOptions.model,
    value: modelOptions.model,
  }));
};

export { useModels };
